import * as turf from '@turf/turf'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import type { GroundInvestigationPoint } from '@/stores/type/giPoint.type'
import { SectionSelectionPolygon } from '@/stores/type/selectionPolygon.type'

export const getPointsInsidePolygon = (
  polygon: turf.AllGeoJSON,
  giPointsArray: GroundInvestigationPoint[]
): GroundInvestigationPoint[] => {
  const giPoints: GroundInvestigationPoint[] = []
  giPointsArray.forEach((giPoint) => {
    const coordinates = { ...giPoint.geometry.coordinates }

    const point = turf.point([coordinates[1], coordinates[0]])

    if (booleanPointInPolygon(point, polygon)) {
      giPoints.push(giPoint)
    }
  })
  return giPoints
}

export const findSelectionGIPointsIDs = (
  polygons: SectionSelectionPolygon[],
  giPointsArr: GroundInvestigationPoint[]
) => {
  if (polygons.length === 0 || giPointsArr.length === 0) return []
  return polygons.flatMap((polygon) => {
    const coordinates = polygon.geometry.coordinates[0].map(([lng, lat]) => [lat, lng])
    const turfPolygon = turf.polygon([coordinates])
    return getPointsInsidePolygon(turfPolygon, giPointsArr).map((point) => point.id)
  })
}

export const findGIPointsToRemove = (
  polygonToRemove: SectionSelectionPolygon,
  allPolygons: SectionSelectionPolygon[],
  giPointsArr: GroundInvestigationPoint[]
): number[] => {
  const overlappingPolygons = allPolygons.filter((polygon) => polygon.id !== polygonToRemove.id)

  const giPointsInPolygonToRemove = findSelectionGIPointsIDs([polygonToRemove], giPointsArr)

  const giPointsInOverlappingPolygons = findSelectionGIPointsIDs(overlappingPolygons, giPointsArr)

  return giPointsInPolygonToRemove.filter(
    (pointId) => !giPointsInOverlappingPolygons.includes(pointId)
  )
}
